import axios from "axios";
import { credenciales } from "./credenciales";
import { getApiUrl } from "./Api";

export const BackendRecursoContexto = async (recursoContexto: string) => {
  const { IdSesion, tokenBacked } = await credenciales();
  let url = getApiUrl("" + process.env.REACT_APP_RECURSOCONTEXTO);
  axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=utf-8";
  axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";

  let data = JSON.stringify({
    description: recursoContexto,
  });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: url,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: "Bearer " + tokenBacked,
      IdSesion: "" + IdSesion,
    },
    data: data,
  };

  return await axios(config);
};
